/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React from 'react';
import { NavLink } from 'react-router-dom';

import closeIco from 'assets/images/close-btn-violet.svg';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToString from 'utils/converters/fromAnyToString';

import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';

class MarketingTextHeader extends React.Component {
  constructor(props) {
    super(props);

    this.myRef = React.createRef();
    this.state = {
      marketingInfo: false,
      purchaseModal: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideText);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideText);
  }

  // eslint-disable-next-line react/sort-comp
  handleClickOutsideText = (e) => {
    if (this.myRef && this.myRef.current) {
      if (!this.myRef.current.contains(e.target)) {
        this.setState({ marketingInfo: false });
      }
    }
  };

  // FIXME: seems unused, delete it
  handleClickInside = () => this.setState({ marketingInfo: true });
  handleClickInsideText = () => this.setState({ marketingInfo: true });
  getMoreText = () => void this.showPurchasePopup(true);
  closeMarketingDropdown = () => void this.setState({ marketingInfo: false });
  closePurchaseModal = () => void this.setState({ purchaseModal: false });

  gotoBilling = () => {
    const oldpath = this.props.history.location.pathname;
    let newPath;
    if (oldpath.indexOf('day') > 0) {
      newPath = `${oldpath.split('day/')[0]}settings/billing`;
    } else if (oldpath.indexOf('communications') > 0) {
      newPath = `${oldpath.split('communications/')[0]}settings/billing`;
    } else {
      newPath = `${oldpath.split('week/')[0]}settings/billing`;
    }
    this.props.history.push({ pathname: newPath });
  };

  showPurchasePopup = (tf) => void this.setState({ purchaseModal: tf });

  render() {
    const t = this.props.t;
    const date = new Date();
    const time = new Date(date.getTime());
    time.setMonth(date.getMonth() + 1);
    time.setDate(0);
    const daysLeft = time.getDate() > date.getDate() ? time.getDate() - date.getDate() : 0;

    const linkBuckets = fromAnyToString(this.props.bucketsPath) || '#';
    const linkClientConnect = fromAnyToString(this.props.clientConnectPath) || '#';
    const linkMarketing = fromAnyToString(this.props.marketingPath) || '#';

    return (
      <div className="marketing-text-header">
        <div className="text-remaining" ref={this.myRef} role="button" tabIndex={0} onClick={this.handleClickInsideText}>
          {this.props.sms_credits_available ? (
            <label>
              <div>{t('scheduler.marketing.textsToUse')}</div>
              <span>{this.props.sms_credits_available.toLocaleString('en-US')}</span>
            </label>
          ) : (
            <label>
              <div>{t('scheduler.marketing.textsToUse')}</div>
              <span>0</span>
            </label>
          )}
          <div className="circle">
            <span>i</span>
          </div>
          {this.state.marketingInfo && (
            <div className="dropdown-marketing-info">
              <div className="arrow" />
              <div className="scroll-container">
                <strong>{`${t('scheduler.marketing.purchasedTexts')} ${this.props.sms_credits_purchased_available.toLocaleString('en-US')}`}</strong>
                <strong className="purple">
                  {`${t('scheduler.marketing.freeTexts')} ${this.props.sms_credits_free_available.toLocaleString('en-US')}`}
                  <small>
                    ({daysLeft} {t('scheduler.marketing.daysLeft')})
                  </small>
                </strong>
                <strong className="underline">{t('scheduler.marketing.usage.title')}</strong>
                <p className="cfix  relative">
                  {t('scheduler.marketing.usage.tip1Part1')}{' '}
                  <NavLink to={linkBuckets} activeClassName="active">
                    {t('scheduler.marketing.usage.tip1Part2')}
                  </NavLink>
                  <TooltipForReceptionist where={IN.textDropFirst} />
                </p>
                <p className="cfix  relative">
                  {t('scheduler.marketing.usage.tip2Part1')}
                  <NavLink to={linkClientConnect} activeClassName="active">
                    {t('scheduler.marketing.tips.tip2Part2')}
                  </NavLink>
                  <TooltipForReceptionist where={IN.textDropSecond} />
                </p>
                <p> {t('scheduler.marketing.tips.tip3')}</p>

                <strong className="underline">{t('scheduler.marketing.subscriptions.title')}</strong>
                <p>{t('scheduler.marketing.subscriptions.tip1')}</p>
                <p>{t('scheduler.marketing.subscriptions.tip2')}</p>
              </div>
            </div>
          )}
        </div>
        {this.state.marketingInfo && (
          <>
            <div onClick={this.closeMarketingDropdown} role="button" tabIndex={0} className="btn-close-info">
              <img src={closeIco} alt="Close Marketing Info" />
            </div>
            <div className="close-text-overlay" onClick={this.closeMarketingDropdown} role="button" tabIndex={0} />
          </>
        )}
        <div className="btn-container">
          <div role="button" tabIndex={0} className="btn-light" onClick={this.getMoreText}>
            {t('scheduler.marketing.purchaseTextsButton')}
          </div>
          <div className="cfix  relative btn-light">
            <NavLink to={linkMarketing} activeClassName="active" className="btn-with-permission">
              {t('scheduler.marketing.marketingLink')}
            </NavLink>
            <TooltipForReceptionist where={IN.textClient} />
          </div>
        </div>
        {this.state.purchaseModal && (
          <PurchaseSmsCreditDialog
            closePopup={this.closePurchaseModal}
            purchaseSmsBundle={this.props.purchaseSmsBundle}
            salonId={this.props.salonId}
            errorMessage={this.props.errorMessage}
            gotoBilling={this.gotoBilling}
            isFetching={this.props.isFetching}
            sms_credits_available={this.props.sms_credits_available}
            showPurchasePopup={this.showPurchasePopup}
            permission={this.props.permission}
            fetchSalon={this.props.fetchSalon}
            variantButton="normal"
          />
        )}
      </div>
    );
  }
}

const MarketingTextHeaderHoc = withTranslation()(MarketingTextHeader);

export default MarketingTextHeaderHoc;
